(function () {
  function init(root) {
    if (!root || root.dataset.fieldenBlogReady === 'true') return;
    root.dataset.fieldenBlogReady = 'true';

    var loadCount = parseInt(root.getAttribute('data-load-count'), 10) || 6;
    var button = root.querySelector('.fielden_blog_load_more__button');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.fielden_blog_load_more__card'));

    if (!button || !cards.length) return;

    function hiddenCards() {
      return cards.filter(function (card) {
        return card.classList.contains('is-hidden');
      });
    }

    function syncButton() {
      if (hiddenCards().length === 0) {
        button.hidden = true;
        button.classList.add('is-hidden');
      } else {
        button.hidden = false;
        button.classList.remove('is-hidden');
      }
    }

    button.addEventListener('click', function () {
      hiddenCards().slice(0, loadCount).forEach(function (card) {
        card.classList.remove('is-hidden');
      });
      syncButton();
    });

    syncButton();
  }

  function initAll(container) {
    var scope = container || document;
    scope.querySelectorAll('.fielden_blog_load_more').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
